<template>
  <v-toolbar color="transparent" flat dense class="text-caption" height="28px">
    <v-spacer />
    <div class="text-centers">
      Powered by <a href="https://restion.ru" target="_blank">RESTION</a>
    </div>
    <v-spacer />
  </v-toolbar>
</template>

<script>

export default {
  name: 'PoweredBy',
  props: {
  },
  data: () => ({
  }),
  computed: {
    dark() { return this.$store.state.theme.mainDark; },
    color() { return this.$store.state.theme.mainColor; },
  },
};
</script>
